<template>
  <div class="text-textColor">
    <transition name="fade">
      <form
          @submit.prevent="create"
      >
      <div
          v-if="showCreateDisciplinary"
          class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full overflow-x-scroll"
      >
        <div
            class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/3 w-full"
        >
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Create Disciplinary Record</p>
            <img
                class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
                src="@/assets/icons/cross-white.png"
                @click="close()"
            />
          </div>
          <transition name="fade">
            <div
                v-if="create_error"
                class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <transition name="fade">
            <div
                v-if="create_success"
                class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Type</label>
              <select
                  v-model="info.DisciplinaryTypeId"
                  name=""
                  id=""
                  class="p-2 bg-gray-200 rounded-full w-full"
                  required
              >
                <option value="" disabled>Select disciplinary type</option>
                <option v-for="(type, index) in disciplinaryTypes" :key="index" :value="type.Id">
                  {{ type.Name }}
                </option>
              </select>
            </div>
            <div class="text-sm">
              <label class="block pb-1">Subject</label>
             <input class="p-2 bg-gray-200 rounded-full w-full" v-model="info.Subject">
            </div>

            <div class="text-sm">
              <label class="block pb-1">Comments</label>
              <vue-editor v-model="info.Comments" :editorToolbar="customToolbar"></vue-editor>
            </div>
            <div class="text-sm">
              <label class="block pb-1">Setup Meeting</label>
             <input type="checkbox" v-model="info.SetupMeeting">
            </div>
            <div v-if="info.SetupMeeting">
              <div class="text-sm" >
                <label class="block pb-1">Date and Time</label>
                <input type="datetime-local" class="p-2 bg-gray-200 rounded-full w-full" v-model="info.dateTime">
              </div>
              <div class="text-sm mt-3" >
                <label class="block pb-1">Meeting Details</label>
                <textarea class="p-2 bg-gray-200 w-full rounded" rows="5" v-model="info.MeetingDetails"></textarea>
              </div>
            </div>

          </div>

          <div class="flex justify-end p-5">
            <button
                type="submit"
                class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
      </form>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { VueEditor } from 'vue2-editor';
export default {
  name: "AddAsset",
  components: {VueEditor},
  props: ["showCreateDisciplinary"],
  data() {
    return {
      selectedType: "single",
      assetType: "",
      condition: "",
      assets: [],
      disciplinaryTypes:[],
      info:{
        DisciplinaryTypeId:'',
        Subject:'',
        Comments:'',
        EmployeeId:'',
        DateTime:'',
        SetupMeeting: false,
        MeetingDetails:''
      },
      create_error: null,
      create_success: null,
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ header: [1, 2, 3, false] }],
        [{ align: [] }],
      ],
    };
  },
  created() {
    this.getDisciplinaryTypes()
    this.info.EmployeeId = this.getCurrentEmployeeId
  },
  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getTabTitle",
      "getCurrentEmployeeId",
    ]),
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleSubmit() {
      setTimeout(() => {
        this.close();
      }, 1000);
    },
    getDisciplinaryTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
          .get(
              `${this.getOrganization}/setup/disciplinary/type/${this.$ApiVersion}/request`,
              options
          )
          .then(
              (response) => {
                this.loading = false;
                if (response.data.StatusCode == 200) {
                  //console.log(response.data.Data);
                  this.disciplinaryTypes = response.data.Data;
                } else {
                  this.get_error = response.data.StatusMessage;
                }
              },
              (error) => {
                this.loading = false;
                this.get_error = error.message;
              }
          );
    },
    create() {
      console.log(this.info)
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
          .post(
              `${this.getOrganization}/employee/disciplinary/history/${this.$ApiVersion}/create`,
              JSON.stringify(this.info),
              options
          )
          .then(
              (response) => {
                this.loading = false;
                if (response.data.StatusCode == 200) {
                  this.create_success = response.data.StatusMessage;
                  this.info = {
                    Name: "",
                    Comments: ""
                  };
                  this.$emit('record-created');
                  this.$emit('close')
                } else {
                  this.create_error = response.data.StatusMessage;
                  setTimeout(() => {
                    this.create_error = null;
                  }, 2500);
                }
              },
              (error) => {
                this.loading = false;
                this.create_error = error.message;
              }
          );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
